module.exports = __webpack_public_path__ + "static/img/top-img.742c85b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactpic/top-img.jpg
// module id = Uy1S
// module chunks = 51